import {IEntityBase} from 'models';

const domainKnowledgeQuery = 'knowledge';

export function isDomainKnowledge(domain: IEntityBase) {
  return !!domain && domain.name.toLowerCase().indexOf(domainKnowledgeQuery) > -1;
}
